import { render } from "./MaterialS2.vue?vue&type=template&id=76290a85&scoped=true"
import script from "./MaterialS2.vue?vue&type=script&lang=js"
export * from "./MaterialS2.vue?vue&type=script&lang=js"

import "./MaterialS2.vue?vue&type=style&index=0&id=76290a85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76290a85"]])

export default __exports__